import type { ISwSettings } from "app/@types/ISwSettings";
import { ANNUAL_CAMPAIGN_ID } from "app/components/AnnualPromoModal/configs/buildAnnualCampaignConfig";
import {
    isRoleAdmin,
    isMcpNt,
    isMonthlyPaymentPeriod,
    isNoTouch,
    isSI,
    isTrialOrAfterTrialUser,
} from "app/UtilitiesAndConstants/UtilityFunctions/usersUtils";

const ANNUAL_PROMO_TYPES = [ANNUAL_CAMPAIGN_ID] as const;
export type AnnualPromoType = (typeof ANNUAL_PROMO_TYPES)[number];

/** GrowthBook payload for {@link TestsNames.ANNUAL_PROMOTION}. */
export interface IAnnualPromotionFeatureValue {
    isMarketingGreenlightEnabled: boolean;
    minSubscriptionMonths: number;
    maxSubscriptionMonths: number;
}

export const ANNUAL_PROMOTION_FEATURE_DEFAULTS: IAnnualPromotionFeatureValue = {
    isMarketingGreenlightEnabled: false,
    minSubscriptionMonths: 0,
    maxSubscriptionMonths: 0,
};

export const isAnnualCampaignEligible = (swSettings: ISwSettings, isMarketingGreenlightEnabled: boolean): boolean =>
    !isSI(swSettings) &&
    !isMcpNt(swSettings) &&
    isNoTouch(swSettings) &&
    !isTrialOrAfterTrialUser(swSettings) &&
    isMarketingGreenlightEnabled &&
    isMonthlyPaymentPeriod(swSettings) &&
    isRoleAdmin(swSettings);
